import { memo } from "react";
import { styled } from "styled-components";

import { ListLink } from "common/components/lists/ListLink";
import { BrowseInnerContent, StyledWrapper } from "domains/knowledgeData/components/SharedComponents";
import { KnowledgeDetailButton } from "domains/publication/components/KnowledgeDetailButton";
import type { Source } from "entities/knowledge/types";

const StyledLink = styled(ListLink)`
  text-decoration: none;
  display: flex;
`;

type KnowledgeDataNavigationItemBrowseViewProps = {
  className?: string;
  isSelected?: boolean;
  title: string;
  imageUrl?: string;
  source: Source;
  timestamp?: number;
  showCaret?: boolean;
  detailLink: string;
};

// TODO: Either use this or replace with InteractiveDataListItem
export const KnowledgeDataNavigationItemBrowseView = memo(
  ({
    className,
    isSelected = false,
    title,
    imageUrl,
    source,
    timestamp,
    detailLink,
    showCaret = false,
  }: KnowledgeDataNavigationItemBrowseViewProps) => (
    <StyledWrapper>
      <StyledLink className={className} $isSelected={isSelected} to={detailLink}>
        <BrowseInnerContent title={title} imageUrl={imageUrl} source={source} timestamp={timestamp} />
      </StyledLink>
      {showCaret && <KnowledgeDetailButton link={detailLink} title={title} />}
    </StyledWrapper>
  ),
);

KnowledgeDataNavigationItemBrowseView.displayName = "KnowledgeDataNavigationItemBrowseView";
